export default [
  {
    name: 'Interior Design' ,
    desc: `Aesthetic and function are put together in <span class="font-italic">detailed drawings</span> with
      corresponding <span class="font-italic">material specifications</span>. These elements are carefully developed to
      complete the interior design blue print of the project.`,
    src: 'icon-design.png'
  },
  {
    name: 'Project Management' ,
    desc: `A meticulous process that monitors <span class="font-italic">budget</span>
      and <span class="font-italic">timeline</span>
      is implemented for cost-efficient and timely turnovers.`,
    src: 'icon-project.png'
  },
  {
    name: 'Home Management',
    desc: `Whether you've just moved into your first house, or you've been staying in
      it for the longest time, we know you're always itching
      to improve your home sweet home!
      We specialize in carpentry, painting, plumbing, electrical
      and mechanical works and all other
      minor and major home improvement & maintenance concerns.`,
    src: 'icon-property.png'
  }
]
